import { render, staticRenderFns } from "./GridFormProviderBuilder.vue?vue&type=template&id=50ecc33f&"
import script from "./GridFormProviderBuilder.vue?vue&type=script&lang=js&"
export * from "./GridFormProviderBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports